<template>
  <div class="table-box">
    <global-tag>
      <el-form label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="套餐类型：">
              <el-input clearable placeholder="请输入" v-model="searchObj.mealType" size="primary"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class='search'>
            <el-form-item label="所属机构:" prop="serviceStation">
              <el-select v-model="searchObj.serviceStation" placeholder="请选择" size="mini" filterable height="40" style="width: 100%">
                <el-option v-for="item in serviceStationList" :key="item.selectTreeId" :label="item.statName"
                  :value="item.selectTreeId">
                </el-option>
              </el-select>
            </el-form-item>
           </el-col>
            <el-col :span="3" :offset="2">
              <el-button type="primary" size="medium" class="searchBtns" @click="getTableData">查询
              </el-button>
            </el-col>
        </el-row>
      </el-form>
    </global-tag>

    <el-button icon="el-icon-plus" class="openBtns" style="margin: 10px 0" type="success" size="medium"
      @click="showDialog('新增')">
      新增
    </el-button>

    <el-table :data="tableData" border style="width: 100%; margin-bottom: 15px" ref="addForm"
      :header-cell-style="{ background: '#f2f2f2', color: '#000' }">
      <el-table-column type="index" width="70" label="序号" align="center" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="mealType" label="套餐类型" align="center" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="serviceDuration" label="服务时长(分钟)" align="center" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="serviceNumber" label="服务项目数量" align="center" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="serviceStationName" label="所属机构" align="center" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="states" label="状态" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-switch active-value="1" inactive-value="0" @change="onStatusChange(scope.row)" v-model="scope.row.states"
            active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button @click="showDialog('查看', scope.row.id)" type="text">查看
          </el-button>
          <el-button @click="showDialog('编辑', scope.row.id)" type="text">编辑
          </el-button>
          <el-button @click="deleteItem(scope.row.id)" type="text">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pageConfig.pageNo" :page-sizes="[5, 10, 20, 50]" :page-size="pageConfig.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="pageConfig.total">
    </el-pagination>

    <!-- 表单弹框-->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form :disabled="dialogTitle === '查看'" :model="addForm" :rules="rules" ref="addForm" label-width="120px">
        <el-form-item label="所属机构:" prop="serviceStation">
          <el-select v-model="addForm.serviceStation" placeholder="请选择" size="mini" filterable style="width: 100%">
            <el-option v-for="item in serviceStationList" :key="item.selectTreeId" :label="item.statName"
              :value="item.selectTreeId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="套餐类型:" prop="mealType">
          <el-input v-model="addForm.mealType" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="服务时长:" prop="serviceDuration">
          <el-input onkeyup="value=value.replace(/[^\d]/g,'')" v-model.number="addForm.serviceDuration"
            placeholder="请输入"><i slot="suffix">分钟</i></el-input>
        </el-form-item>
        <el-form-item label="时长选择:" prop="selectDurationStatus">
          <el-radio-group v-model="addForm.selectDurationStatus">
            <el-radio label="2">大于服务时长</el-radio>
            <el-radio label="1">小于服务时长</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务项目数量:" prop="serviceNumber">
          <el-input onkeyup="value=value.replace(/[^\d]/g,'')" v-model.number="addForm.serviceNumber"
            placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="价格:" prop="price">
          <el-input onkeyup="value=value.replace(/[^\d]/g,'')" v-model.number="addForm.price" placeholder="请输入价格"><i
              slot="suffix">元</i></el-input>
        </el-form-item>
        <el-form-item label="状态:" prop="states">
          <el-radio-group v-model="addForm.states">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div v-if="dialogTitle !== '查看'" style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 15px;
        ">
        <el-button @click="send" type="primary">确定</el-button>
        <el-button @click="handleClose" type="info">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headLine from "../components/headline"
import request from "@/utils/request.js"

export default {
  components: {
    headLine,
  },
  data() {
    return {
      searchObj: {},
      dialogTitle: "",
      dialogVisible: false,
      addForm: {
        selectDurationStatus: "2",
        serviceStation: null,
      },
      rules: {
        serviceStation: [
          {
            required: true,
            message: "请选择所属机构",
            trigger: "change",
          },
        ],
        mealType: [
          {
            required: true,
            message: "请输入套餐类型",
            trigger: "blur",
          },
        ],
        serviceDuration: [
          {
            required: true,
            message: "请选择服务时长",
            trigger: "blur",
          },
        ],
        serviceNumber: [
          {
            required: true,
            message: "请输入服务项目数量",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur",
          },
        ],
        selectDurationStatus: [
          {
            required: true,
            message: "请选择时长选择",
            trigger: "blur",
          },
        ],

        states: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },
      tableData: [],
      // 分页
      pageConfig: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      isSearchContent: true,
      serviceStationList: [],
    }
  },
  created() {
    this.getTableData()
    this.getTreeChecked()
  },
  methods: {
    getTreeChecked(id) {
      this.$http
        .request({
          url: "/jjyl/admin/serviceStation/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              return
            }
            this.serviceStationList = res.content.list.map((item) => {
              return {
                selectTreeId: item.id, //id
                statName: item.statName,
              }
            })
          }
        })
    },
    Reset() {
      this.searchObj = {}
      this.getTableData()
    },
    // 数据状态发生改变
    onStatusChange(row) {
      request({
        url: "/jjyl/admin/meal/info/insert",
        method: "POST",
        data: row,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(`修改状态成功`)
        } else {
          this.$message.success(`修改状态失败`)
        }
        this.getTableData()
      })
    },
    // 提交
    send() {
      this.$refs.addForm.validate((valid) => {
        // 校验通过
        if (valid) {
          let ff = false
          if (this.addForm.serviceNumber <= 0) {
            this.$message("请输入大于0的正整数")
            this.addForm.serviceNumber = ""
            ff = true
          }
          if (!ff) {
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            })
            request({
              url: "/jjyl/admin/meal/info/insert",
              method: "POST",
              data: this.addForm,
            })
              .then((res) => {
                if (res.code === 200) {
                  loading.close()
                  this.$message.success(`${this.dialogTitle}成功`)
                } else {
                  loading.close()
                  this.$message.success(`${this.dialogTitle}失败`)
                }
                this.handleClose()
                this.getTableData()
              })
              .catch((error) => {
                loading.close()
                this.handleClose()
              })
          }
        }
      })
    },
    // 删除某一项
    deleteItem(id) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          request({
            url: "/jjyl/admin/meal/info/deleteById",
            method: "POST",
            data: {
              id,
            },
          }).then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功!")
              this.getTableData()
            } else {
              this.$message.success("删除失败!")
            }
          })
        })
        .catch(() => {
          this.$message.info("已取消删除")
        })
    },
    // 显示弹框
    showDialog(title, id) {
      this.dialogTitle = title
      this.dialogVisible = true
      this.addForm.selectDurationStatus = "2"
      if (title !== "新增" && id) {
        request({
          url: "/jjyl/admin/meal/info/findById",
          method: "POST",
          data: {
            id,
          },
        }).then((res) => {
          if (res.code === 200) {
            this.addForm = res.content || {}
          }
        })
      }
    },
    // 关闭弹框
    handleClose() {
      this.dialogVisible = false
      this.addForm = {}
      this.$refs.addForm.resetFields()
    },
    // 每页显示条数切换
    handleSizeChange(val) {
      this.pageConfig.pageSize = val
      this.getTableData()
    },
    // 页码切换
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getTableData()
    },
    // 获取列表数据
    getTableData() {
      request({
        url: "/jjyl/admin/meal/info/findList",
        method: "POST",
        data: {
          pageNo: this.pageConfig.pageNo,
          pageSize: this.pageConfig.pageSize,
          ...this.searchObj,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.tableData = res.content.list || []
          this.pageConfig.total = res.content.count || 0
        }
      })
    },
  },
}
</script>
<style >
  .search /deep/.el-input__inner{
    height:40px;
    line-height:40px
  }
</style>
<style lang="less" scoped>

.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}
</style>
